export default (axios, alert) => ({
  berufe () {
    return axios.get('/public/berufe').then(({ data }) => data.data).catch(() => {
      alert('Fehler beim Laden der Berufsgruppen', true)
    })
  },

  confirmWiderruf (token) {
    return axios.post('/customer/widerruf/confirm', { token })
  }
})
